module.exports = {"152502001":"希日塔拉街道","152502002":"宝力根街道","152502003":"杭盖街道","152502004":"楚古兰街道","152502005":"额尔敦街道","152502006":"南郊街道","152502007":"巴彦查干街道","152502100":"阿尔善宝拉格镇","152502200":"宝力根苏木","152502201":"朝克乌拉苏木","152502202":"巴彦锡勒乡","152502203":"巴彦宝拉格苏木","152502400":"锡林郭勒盟经济技术开发区","152502500":"白音库伦牧场","152502501":"贝力克牧场","152502502":"毛登牧场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/152502.json
// module id = 484
// module chunks = 0